export default "__VITE_ASSET__DIGlrvJn__"